const languageMapping: {
    [key: string]: { caption: string; locale: string };
  } = {
    English: { caption: "English", locale: "en" },
    Korean: { caption: "한국어 (Korean)", locale: "kr" },
    Japanese: { caption: "日本語 (Japanese)", locale: "jp" },
    Thai: { caption: "ภาษาไทย (Thai)", locale: "th" },
  };
  
  export default languageMapping;